import _ from 'lodash';
import React, { Component } from 'react';
import './CategoryCard.css';
import history from '../../utils/history';
import { connect } from 'react-redux';
import * as actions from '../../actions';

class CategoryCard extends Component {

	updateFilters () {
        const { item } = this.props;
        /**
         * this is where we can build a state of the filters
         * we will use this filter state in other components
         * such as the propject map component
         */
        this.props.updateFilters(item);
        history.replace('/projects');
    }

    render() {
        const { title, imageLogo } = this.props.item;

        return (
            <div className="category-card tikki-shadow" onClick={this.updateFilters.bind(this)}>
                <div>
                    <img
                        src={imageLogo}
                        alt=""
                        className="category-card-md-logo responsive-img"
                    />
                </div>
                <div>
                    <p className="category-card-title">{title}</p>
                </div>
            </div>
        );
    };
};

function mapStateToProps({ filters }) {
    return {
        filters
    };
}

export default connect(mapStateToProps, actions)(CategoryCard);



// WEBPACK FOOTER //
// ./src/components/Categories/CategoryCard.js